/* ============================================================
   BUNON — shared behaviour: header, drawer, language toggle,
   scroll reveal, review carousel, countdown, toast
   ============================================================ */
(function () {
  "use strict";

  var $ = function (sel, root) { return (root || document).querySelector(sel); };
  var $$ = function (sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); };

  /* ---------- Sticky header shadow ---------- */
  var header = $(".bunon-header");
  if (header) {
    var onScroll = function () {
      header.classList.toggle("scrolled", window.scrollY > 8);
    };
    window.addEventListener("scroll", onScroll, { passive: true });
    onScroll();
  }

  /* ---------- Mobile drawer ---------- */
  var drawer = $(".bunon-drawer");
  var scrim = $(".bunon-drawer-scrim");
  var menuBtn = $(".bunon-menu-btn");
  function setDrawer(open) {
    if (!drawer) return;
    drawer.classList.toggle("open", open);
    scrim && scrim.classList.toggle("open", open);
    menuBtn && menuBtn.setAttribute("aria-expanded", String(open));
    document.body.style.overflow = open ? "hidden" : "";
  }
  menuBtn && menuBtn.addEventListener("click", function () {
    setDrawer(!drawer.classList.contains("open"));
  });
  scrim && scrim.addEventListener("click", function () { setDrawer(false); });
  var drawerCloseBtn = drawer && drawer.querySelector(".bunon-drawer__close");
  drawerCloseBtn && drawerCloseBtn.addEventListener("click", function () { setDrawer(false); });
  document.addEventListener("keydown", function (e) {
    if (e.key === "Escape") setDrawer(false);
  });
  /* Close drawer when clicking a link inside */
  if (drawer) {
    $$("a", drawer).forEach(function (link) {
      link.addEventListener("click", function () { setDrawer(false); });
    });
  }

  /* ---------- Language toggle (BN/EN) ---------- */
  var LANG_KEY = "bunon-lang";
  function applyLang(lang) {
    document.documentElement.setAttribute("data-lang", lang);
    $$("[data-bn]").forEach(function (el) {
      var txt = el.getAttribute(lang === "bn" ? "data-bn" : "data-en");
      if (txt !== null) el.textContent = txt;
    });
    $$(".bunon-lang-toggle").forEach(function (btn) {
      btn.textContent = lang === "bn" ? "EN" : "বাংলা";
      btn.setAttribute("aria-label", lang === "bn" ? "Switch to English" : "বাংলায় দেখুন");
    });
    /* Sections that render their own copy (PDP pricing, bundle table, the
       pre-order popup) re-render off this instead of re-reading data-bn. */
    document.dispatchEvent(new CustomEvent("bunonLangChange", { detail: { lang: lang } }));
  }
  var savedLang = "bn";
  try { savedLang = localStorage.getItem(LANG_KEY) || "bn"; } catch (e) {}
  applyLang(savedLang);
  $$(".bunon-lang-toggle").forEach(function (btn) {
    btn.addEventListener("click", function () {
      var next = document.documentElement.getAttribute("data-lang") === "bn" ? "en" : "bn";
      applyLang(next);
      try { localStorage.setItem(LANG_KEY, next); } catch (e) {}
    });
  });

  /* ---------- Scroll reveal ---------- */
  var toReveal = $$(".bunon-reveal");
  if ("IntersectionObserver" in window && toReveal.length) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add("in");
          io.unobserve(entry.target);
        }
      });
    }, { rootMargin: "0px 0px -8% 0px", threshold: 0.08 });
    toReveal.forEach(function (el) { io.observe(el); });
  } else {
    toReveal.forEach(function (el) { el.classList.add("in"); });
  }

  /* ---------- Review carousel arrows ---------- */
  $$("[data-bunon-carousel]").forEach(function (region) {
    var track = $(".bunon-rv-track", region);
    if (!track) return;
    var step = function () {
      var card = track.firstElementChild;
      return card ? card.getBoundingClientRect().width + 16 : 320;
    };
    var prev = $("[data-prev]", region);
    var next = $("[data-next]", region);
    prev && prev.addEventListener("click", function () { track.scrollBy({ left: -step(), behavior: "smooth" }); });
    next && next.addEventListener("click", function () { track.scrollBy({ left: step(), behavior: "smooth" }); });
  });

  /* ---------- Countdown timer ---------- */
  $$("[data-bunon-countdown]").forEach(function (cd) {
    var target = new Date(cd.getAttribute("data-bunon-countdown")).getTime();
    var cells = {
      d: $("[data-cd-d]", cd), h: $("[data-cd-h]", cd),
      m: $("[data-cd-m]", cd), s: $("[data-cd-s]", cd)
    };
    var pad = function (n) { return String(n).padStart(2, "0"); };
    var tick = function () {
      var diff = target - Date.now();
      if (diff <= 0) { cd.style.display = "none"; return; }
      var s = Math.floor(diff / 1000);
      cells.d && (cells.d.textContent = pad(Math.floor(s / 86400)));
      cells.h && (cells.h.textContent = pad(Math.floor(s % 86400 / 3600)));
      cells.m && (cells.m.textContent = pad(Math.floor(s % 3600 / 60)));
      cells.s && (cells.s.textContent = pad(s % 60));
      setTimeout(tick, 1000);
    };
    tick();
  });

  /* ---------- Toast system ---------- */
  var toastTimer;
  function showToast(msg) {
    var t = $("#bunon-toast");
    if (!t) {
      t = document.createElement("div");
      t.id = "bunon-toast";
      t.setAttribute("role", "status");
      t.style.cssText =
        "position:fixed;left:50%;bottom:28px;transform:translateX(-50%) translateY(8px);" +
        "background:var(--indigo-900);color:var(--on-indigo);padding:12px 22px;" +
        "border-radius:4px;border-left:3px solid var(--gold-500);font-size:.875rem;" +
        "box-shadow:var(--shadow-3);z-index:100;opacity:0;transition:opacity .3s,transform .3s;max-width:88vw;" +
        "font-family:var(--font-body);";
      document.body.appendChild(t);
    }
    t.textContent = msg;
    requestAnimationFrame(function () {
      t.style.opacity = "1";
      t.style.transform = "translateX(-50%) translateY(0)";
    });
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () {
      t.style.opacity = "0";
      t.style.transform = "translateX(-50%) translateY(8px)";
    }, 2600);
  }
  window.bunonToast = showToast;

  /* ============================================================
     BunonCart — the single add-to-cart / refresh path.
     Product page, product cards and the drawer upsell all call
     this, so the drawer is re-rendered and the header badge is
     re-synced the same way no matter what triggered the add.
     ============================================================ */
  function cartRoot() {
    return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || "/";
  }

  /* Header badge (and any other [data-cart-count]) from a live count. */
  function syncCount(count) {
    $$("[data-cart-count]").forEach(function (el) {
      el.textContent = String(count);
      el.classList.toggle("hidden", !count);
    });
    /* Dawn's own bubble, if a Dawn header is ever used alongside. */
    $$(".cart-count-bubble span[aria-hidden]").forEach(function (el) {
      el.textContent = String(count);
    });
  }

  function fetchCount() {
    return fetch(cartRoot() + "cart.js", { headers: { Accept: "application/json" } })
      .then(function (r) { return r.json(); })
      .then(function (cart) { syncCount(cart.item_count); return cart; });
  }

  /* Re-render the drawer from the server and re-open it. Replacing
     innerHTML is safe here: CartDrawer listens for clicks on itself
     (delegated), so close-on-outside-click survives the swap. */
  function refreshDrawer(open) {
    var drawer = document.querySelector("cart-drawer");
    if (!drawer) return Promise.resolve();
    return fetch(cartRoot() + "?section_id=cart-drawer", { headers: { Accept: "text/html" } })
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, "text/html");
        var fresh = doc.querySelector("cart-drawer");
        if (!fresh) return;
        drawer.innerHTML = fresh.innerHTML;
        drawer.classList.toggle("is-empty", fresh.classList.contains("is-empty"));
        var items = drawer.querySelector("cart-drawer-items");
        if (items && !fresh.querySelector("cart-drawer-items.is-empty")) items.classList.remove("is-empty");
        if (open) drawer.open();
      });
  }

  function addToCart(variantId, quantity, opts) {
    opts = opts || {};
    var id = parseInt(variantId, 10);
    if (!id) return Promise.reject(new Error("Missing variant id"));
    var line = { id: id, quantity: quantity || 1 };
    /* Line item properties ride along when the caller has them (pre-orders
       send the promised ship date, which then shows on the order, the
       packing slip and the confirmation email). */
    if (opts.properties && Object.keys(opts.properties).length) line.properties = opts.properties;
    return fetch(cartRoot() + "cart/add.js", {
      method: "POST",
      headers: { "Content-Type": "application/json", Accept: "application/json" },
      body: JSON.stringify({ items: [line] })
    })
      .then(function (r) {
        return r.json().then(function (data) {
          if (!r.ok) throw new Error(data.description || data.message || "Add to cart failed");
          return data;
        });
      })
      .then(function (data) {
        return Promise.all([fetchCount(), refreshDrawer(opts.openDrawer !== false)]).then(function () {
          return data;
        });
      });
  }

  window.BunonCart = {
    add: addToCart,
    refreshDrawer: refreshDrawer,
    syncCount: syncCount,
    fetchCount: fetchCount
  };

  /* Keep the header badge honest after any cart mutation — including the
     +/− steppers inside the drawer, which publish cartUpdate from cart.js. */
  if (typeof subscribe === "function" && typeof PUB_SUB_EVENTS !== "undefined") {
    subscribe(PUB_SUB_EVENTS.cartUpdate, function (event) {
      var count = event && event.cartData && event.cartData.item_count;
      if (typeof count === "number") syncCount(count);
      else fetchCount();

      /* Dawn publishes every cart mutation with source "cart-items", so the
         drawer's own subscriber can't tell "I did this" from "the cart page
         did this" and skips both — leaving a closed drawer holding stale
         totals. Refresh it here, but only while it is closed, so we never
         yank the DOM out from under someone mid-interaction. */
      var drawer = document.querySelector("cart-drawer");
      if (drawer && !drawer.classList.contains("active")) refreshDrawer(false);
    });
  }
  document.addEventListener("cart:refresh", function () { fetchCount(); });

  /* ---------- Cart drawer trigger ---------- */
  $$("[data-cart-drawer-trigger]").forEach(function (el) {
    el.addEventListener("click", function (e) {
      var cartDrawer = document.querySelector("cart-drawer");
      if (cartDrawer) {
        e.preventDefault();
        cartDrawer.open();
      }
    });
  });

  /* ---------- Product-card add to cart (homepage collection rows) ---------- */
  document.addEventListener("click", function (e) {
    var btn = e.target.closest("[data-bunon-atc]");
    if (!btn) return;
    e.preventDefault();
    if (btn.getAttribute("aria-busy") === "true") return;
    var original = btn.dataset.originalLabel || btn.textContent.trim();
    btn.dataset.originalLabel = original;
    btn.setAttribute("aria-busy", "true");
    addToCart(btn.getAttribute("data-bunon-atc"), 1, { openDrawer: true })
      .then(function () {
        btn.classList.add("is-added");
        btn.textContent = btn.dataset.addedLabel || "✓ যোগ হয়েছে";
        setTimeout(function () {
          btn.classList.remove("is-added");
          btn.textContent = original;
        }, 1800);
      })
      .catch(function (err) {
        showToast(err.message || "কার্টে যোগ করা যায়নি");
      })
      .finally(function () {
        btn.removeAttribute("aria-busy");
      });
  });

  /* ---------- Shopify Theme Editor re-init ---------- */
  if (Shopify && Shopify.designMode) {
    document.addEventListener("shopify:section:load", function () {
      /* Re-run reveal for newly loaded sections */
      var newReveals = $$(".bunon-reveal:not(.in)");
      newReveals.forEach(function (el) { el.classList.add("in"); });
    });
  }
})();
